"use client";

import type React from "react";
import { useEffect, useState } from "react";

// Fix hydration error for some of the Harmonic components
export default function withHydrationFixed(BaseComponent: any) {
	function HydrationFixedBaseComponent(props: any) {
		const [hydrated, setHydrated] = useState(false);

		useEffect(() => {
			setHydrated(true);
		}, []);

		if (!hydrated) {
			// Some Harmonic components are different when rendered on the server and on the client.
			// Return null on the first render (server), thus the client and server rendered content match.
			return null;
		}

		return <BaseComponent {...props} />;
	}

	return HydrationFixedBaseComponent;
}
